import { render, staticRenderFns } from "./FormGroupCheckboxGroup.vue?vue&type=template&id=0a8213d8"
import script from "./FormGroupCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./FormGroupCheckboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports